import { render, staticRenderFns } from "./SingleForm.vue?vue&type=template&id=5cbf367e&"
import script from "./SingleForm.vue?vue&type=script&lang=js&"
export * from "./SingleForm.vue?vue&type=script&lang=js&"
import style0 from "./SingleForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports